import { render, staticRenderFns } from "./helper-instructional.vue?vue&type=template&id=53e02b42&scoped=true"
import script from "./helper-instructional.ts?vue&type=script&lang=ts&external"
export * from "./helper-instructional.ts?vue&type=script&lang=ts&external"
import style0 from "./helper-instructional.vue?vue&type=style&index=0&id=53e02b42&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e02b42",
  null
  
)

export default component.exports